<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("purchaseOrders/getDetails", this.itemId);
    },
    computed: {
        purchaseOrder() {
            return this.$store.state.purchaseOrders.purchaseOrder;
        }
    },
    data() {
        return {
            headers: [
                { text: 'اسم الدواء', value: 'medicineName' },
                { text: ' رقم التشغيلة', value: 'batchNo' },
                { text: 'الكمية', value: 'quantity' },
                { text: 'سعر القطعة', value: 'purchasePrice' },
                { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
            ],
        };
    },
};
</script>